import { useEffect, useState } from 'react'

import RafflePngs from 'assets/png'
import { ScratchCard } from 'components/ScratchCard/ScratchCard'

import { Loading } from '@interco/inter-ui/components/Loading'

import * as S from './LoadingGame.styles'

export const LoadingGame = () => {
  const [isAnimated, setIsAnimated] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setIsAnimated(!isAnimated)
    }, 100)
  }, [])

  return (
    <S.Content data-testid="loading-game-container">
      <S.Elipse />
      <S.List className={isAnimated ? 'animated' : ''}>
        <ScratchCard scale={400}>{RafflePngs.carouselGift}</ScratchCard>
        <ScratchCard scale={500}>
          {RafflePngs.carouselGift}
          <S.Loading>
            <Loading width={32} height={32} color="var(--static-base-white)" />
          </S.Loading>
        </ScratchCard>
        <ScratchCard scale={400}>{RafflePngs.carouselGift}</ScratchCard>
      </S.List>
    </S.Content>
  )
}
